export default __webpack_public_path__ + "static/media/holiday-box-set-2022.1ef50cbf.jpg";